import { render, staticRenderFns } from "./category.vue?vue&type=template&id=9b58f3be&"
import script from "./category.vue?vue&type=script&lang=js&"
export * from "./category.vue?vue&type=script&lang=js&"
import style0 from "./category.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b58f3be')) {
      api.createRecord('9b58f3be', component.options)
    } else {
      api.reload('9b58f3be', component.options)
    }
    module.hot.accept("./category.vue?vue&type=template&id=9b58f3be&", function () {
      api.rerender('9b58f3be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configure/category.vue"
export default component.exports